import React, { Component } from 'react';

import styles from './Time.module.css'

interface TimeProps {
    // How many secons by pixels should we use
    secondsByPixel: number;
    // Timeline duration
    timelineDuration: number;
    // Timeline start
    timelineStart: Date;
    // Small and big ticks range
    tickRanges: number[];
}


export class Time extends Component<TimeProps, {}> {

    private container: HTMLDivElement | null;

    public static getRanges() {
        return [
            // [1, 0.2],        // 1 second
            // [2, 0.5],        // 2 seconds
            // [10, 2],         // 10 seconds
            // [15, 5],         // 15 seconds
            [30, 10],           // 30 seconds
            [60, 20],           // 1 minute
            // [120, 30],       // 2 minutes
            [300, 60],          // 5 minutes
            // [600, 120],      // 10 minutes
            // [900, 300],      // 15 minutes
            // [1800, 600],     // 30 minutes
            [3600, 1200],       // 1 hour
            [7200, 1200],       // 2 hours
        ];
    }

    public render() {
        this.draw();
        return <div
            className={styles.container}
            ref={(c) => { this.container = c; }}
        >
            {this.draw()}
        </div>;
    }

    public componentDidUpdate() {
        const active = `ticker_range_${this.props.tickRanges[0]}_${this.props.tickRanges[1]}`;

        Time.getRanges().forEach((values: number[]) => {
            const current = `ticker_range_${values[0]}_${values[1]}`;

            Array.from(document.getElementsByClassName(current)).forEach((element: HTMLElement) => {
                element.style.display = (current === active) ? 'block' : 'none';
            });
        });
    }


    private draw(): React.ReactNode[] {
        if (this.container === null) {
            return [];
        }
        const res: React.ReactNode[] = [];
        // const [big, small] = this.props.tickRanges;
        Time.getRanges().forEach((values: number[]) => {
            const className = `ticker_range_${values[0]}_${values[1]}`;

            res.push(this.drawTickEvery(values[0], 2, 25, className));
            res.push(this.drawTickEvery(values[1], 1, 10, className));
            res.push(this.drawText(values[0], className));
        })
        return res;
    }

    private drawTickEvery(seconds: number, width: number, height: number, className: string): React.ReactNode[] {
        const duration = this.props.timelineDuration;
        let left = 0;
        let key = 1;
        const elements: React.ReactNode[] = [];

        for (let i = 0; i <= duration; i += seconds) {
            elements.push(
                <div
                    className={styles.tick + ' ' + className}
                    key={`tick_${key++}_${seconds}`}
                    style={{
                        borderWidth: width,
                        height,
                        left: `${left * 100}%`,
                    }}
                />
            );
            left += (seconds / this.props.timelineDuration);
        }
        return elements;
    }

    private drawText(interval: number, className: string): React.ReactNode[] {
        let time = this.props.timelineStart.getTime();
        const duration = this.props.timelineDuration;
        let left = 0;
        const elements: React.ReactNode[] = [];
        let key = 1;

        for (let i = 0; i <= duration; i += interval) {
            const date = new Date(time);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const text = ((hours < 10) ? '0' : '') + hours + ':' +
                ((minutes < 10) ? '0' : '') + minutes + ':' +
                ((seconds < 10) ? '0' : '') + seconds;

            elements.push(
                <div
                    className={styles.timeText + ' ' + className}
                    key={`timeText_${key++}_${interval}`}
                    style={{
                        left: `${left * 100}%`,
                    }}
                >
                    {text}
                </div>,
            );
            time += interval * 1000;
            left += (interval / this.props.timelineDuration);
        }
        return elements;
    }
}
